import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/dashboard/AdminSidebar";
import AdminTopbar from "../components/dashboard/AdminTopbar";
import "../assets/css/admin-dashboard.css";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      {/* Sidebar */}
      <AdminSidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Topbar */}
      <AdminTopbar sidebarOpen={sidebarOpen} />

      {/* Main Content */}
      <div
        className={`ad-content ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      >
        <Outlet />
      </div>
    </>
  );
};

export default AdminLayout;
